import { render, staticRenderFns } from "./vTabs.vue?vue&type=template&id=3dac2bc6&scoped=true"
import script from "./vTabs.vue?vue&type=script&lang=js"
export * from "./vTabs.vue?vue&type=script&lang=js"
import style0 from "./vTabs.vue?vue&type=style&index=0&id=3dac2bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac2bc6",
  null
  
)

export default component.exports